import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { useProductData } from '../contexts/ProductDataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteProductModal = ({
  onConfirm,
  onReject
}) => {
  const product = useProductData();
  if (!product) {
    return null;
  }
  const productName = getProperty(product, 'name');
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.delete.buttons.confirm"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.delete.message",
      options: {
        productName
      }
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.delete.header"
    }),
    size: "auto",
    use: "danger",
    onConfirm: onConfirm,
    onReject: onReject,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "modal.delete.buttons.reject"
    })
  });
};